<template>
  <v-dialog v-model="visible" max-height="500" max-width="700">
    <v-card>

      <v-toolbar dense color="gray" dark>
        <v-toolbar-title class="title" justify="center">Bearbeiten Standort/Sozialgefüge</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="submitForm">
          <v-row>
            <v-col cols="5">
              <label for="name:">Abkürzung</label>
              <v-text-field class="textFieldOne" outlined v-model.trim="location.abbreviation"
                :rules=rules.abbreviation></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="name:">Beschreibung</label>
              <v-text-field class="textFieldTwo" outlined v-model.trim="location.name" :rules=rules.name></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-btn type="submit" class="emptyForm" style="margin-left:95px; max-width:360px; text-color:black;"
              :loading="isLoading" color="primary" :disabled="!validForm">
              Speichern</v-btn>
            <v-btn type="button" class="emptyForm" style="margin-left:25px;" :loading="isLoading" color="gray"
              @click="closeModal">Abbrechen</v-btn>

          </v-row>
        </v-form>
        <v-alert type="success" elevation="20" v-show="showAlert" :color="alertColor" class="alert">
          {{ alertText }}
        </v-alert>
      </v-card-text>
    </v-card>
    <delete-location :visible="showDeleteModal" :location="location" :item-list="itemList"
      @close="showDeleteModal = false"></delete-location>
  </v-dialog>
</template>

<script>
import axios from "axios";
import DeleteLocation from './DeleteLocation.vue'

export default {

  props: {
    location: {
      type: Object,
      default: () => ({ id: null, abbreviation: '', name: '' })
    },
    visible: Boolean,
    itemList: Array
  },
  data() {
    return {
      isLoading: false,
      showDeleteModal: false,
      showAlert: false,
      alertText: "",
      alertColor: "",
      rules: {
        abbreviation: [
          (v) => !!v || "Abkürzung ist erforderlich",
          (v) => (v && v.split("").length <= 4) || "Die Abkürzung darf höchstens 4 Wörter umfassen",
        ],
        name: [(v) => !!v || "Deutscher Name ist erforderlich"],
      },
    };
  },
  components: {
    DeleteLocation

  },
  computed: {
    validForm() {
      return !!this.location.abbreviation && !!this.location.name;
    }
  },
  methods: {

    closeModal() {
      this.$emit("close");
    },
    submitForm() {
      this.isLoading = true;

      const requestBody = {
        id: this.location.id,
        abbreviation: this.location.abbreviation,
        name: this.location.name

      };

      if (this.location.id) {
        axios
          .put("/api/Location/Update", requestBody, {
            headers: {
              'Content-Type': 'application/json'
            }
          })

          .then(response => {
            this.isLoading = false;
            const index = this.itemList ? this.itemList.findIndex(item => item.id === response.data.id) : -1;
            if (index >= 0) {
              this.$set(this.itemList, index, response.data);
            }
            if (response.status === 200) {
              this.showAlert = true;
              this.alertColor = "success"
              this.alertText = "Das Standort/Sozialgefüge wurde erfolgreich aktualisiert";
              this.$emit("update-table", true);
              setTimeout(() => {
                this.closeModal();
                this.showAlert = false;
              }, 2000);
            }

          })
          .catch(error => {
            console.log(error);
            this.isLoading = false;
            this.showAlert = true;
            this.alertColor = "error";
            this.alertText = "Fehler beim Erstellen der Standort/Sozialgefüge";
            setTimeout(() => {
              this.showAlert = false;
            }, 2000);
          });
      }
    },

  }
};
</script>
<style>
.delete-modal {
  margin-left: 570px;
  text-decoration: underline;
  margin-top: 13px;
  font-size: 20px;

}

.title {
  margin-left: 2%;

}
</style>
